if (!customElements.get('optical-lens-shell')) {
  const highlightMagicSelector = window.mtHighlightActiveSelector;
  if (typeof highlightMagicSelector === 'function') {
    window.mtHighlightActiveSelector = function (selector) {
      // Generated optical previews have no matching Magic Zoom gallery thumbnail.
      // Its app callback assumes one exists before calling closest().
      if (!selector && !document.querySelector('.MagicToolboxContainer .MagicToolboxSelectorsContainer a.mz-thumb-selected')) return;
      return highlightMagicSelector.apply(this, arguments);
    };
  }

  customElements.define(
    'optical-lens-shell',
    class OpticalLensShell extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form[data-type="add-to-cart-form"]');
        this.productForm = this.closest('product-form');
        this.submitButton = this.productForm && this.productForm.querySelector('[name="add"]');
        this.submitButtonText = this.submitButton && this.submitButton.querySelector('span');
        this.prescriptionButton = this.productForm && this.productForm.querySelector('[data-optical-prescription-open]');
        this.context = this.querySelector('[data-optical-context]');
        this.status = this.querySelector('[data-optical-status]');
        this.framePrice = Number(this.dataset.framePriceCents || 0);
        this.frameCompareAtPrice = Number(this.dataset.frameCompareAtPriceCents || 0);
        this.blueRxLensPrice = Number(this.dataset.blueRxLensPriceCents || 0);
        this.standardLensPrice = Number(this.dataset.standardLensPriceCents || 0);
        this.comboDiscount = Number(this.dataset.comboDiscountCents || 0);
        this.variantAvailable = this.dataset.variantAvailable === 'true';
        this.upgradesEnabled = this.dataset.opticalUpgradesEnabled === 'true';
        this.isRimless = this.dataset.opticalRimless === 'true';
        this.currency = this.dataset.currencyCode || 'AUD';
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.nativeSubmitDisabled = this.submitButton ? this.submitButton.disabled : true;
        this.nativeSubmitLabel = this.submitButtonText ? this.submitButtonText.textContent.trim() : 'Add to cart';
        this.stickySyncToken = 0;
        this.adding = false;
        this.previewMap = this.readPreviewMap();
        this.currentVariantId = String(this.form?.querySelector('[name="id"]')?.value || '');
        this.previewSyncTimers = [];
        this.onFormSubmit = (event) => this.handleFormSubmit(event);

        this.addEventListener('change', () => this.applySelection());
        if (this.form) this.form.addEventListener('submit', this.onFormSubmit, true);
        this.subscribeToVariantChanges();
        this.afterpayContainer = this.closest('.product__info-container');
        if (this.afterpayContainer) {
          this.afterpayObserver = new MutationObserver(() => {
            this.syncAfterpayAmount(this.selection?.total ?? this.framePrice);
          });
          this.afterpayObserver.observe(this.afterpayContainer, {
            childList: true, subtree: true, attributes: true, attributeFilter: ['data-amount']
          });
        }
        this.querySelectorAll('[data-optical-purpose]').forEach((input) => {
          const isStandard = input.dataset.opticalPurpose === 'standard';
          const hasServices = Boolean(this.querySelector(`[data-optical-finish-group="${input.dataset.opticalPurpose}"] [data-optical-service-variant-id]:not([data-optical-service-variant-id=""])[data-optical-service-available="true"]`));
          input.disabled = !isStandard && (!this.upgradesEnabled || !hasServices);
          input.setAttribute('aria-disabled', String(input.disabled));
        });
        if (new URLSearchParams(location.search).get('purpose') === 'blue-light-rx' && this.prescriptionButton?.dataset.opticalBlueRxLabel) {
          this.prescriptionButton.textContent = this.prescriptionButton.dataset.opticalBlueRxLabel;
        }
        this.applyLandingPurpose();
        this.applySelection();
      }

      applyLandingPurpose() {
        const purpose = new URLSearchParams(location.search).get('purpose');
        if (purpose === 'blue-light') {
          const blue = this.querySelector('[data-optical-purpose="blue-light"]');
          const available = this.querySelector('[data-optical-finish-group="blue-light"] [data-optical-service-sku="CO-OPT-NP-BLUE-AR"][data-optical-service-available="true"]');
          if (blue && !blue.disabled && this.variantAvailable && available?.dataset.opticalServiceVariantId) {
            blue.checked = true;
            available.checked = true;
          }
        } else if (purpose === 'blue-light-rx' && this.variantAvailable && this.standardLensPrice > 0) {
          const reminder = this.querySelector('[data-optical-blue-rx-reminder]');
          if (reminder) reminder.hidden = false;
          customElements.whenDefined('optical-prescription-builder').then(() => {
            if (!this.isConnected) return;
            const builder = document.querySelector('optical-prescription-builder');
            if (builder?.dialog && this.prescriptionButton && !this.prescriptionButton.disabled) {
              // The builder defaults an available Blue Filter coating; lens type remains the customer's choice.
              builder.open(this.prescriptionButton);
            }
          });
        }
      }

      subscribeToVariantChanges() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event.data || String(event.data.sectionId) !== String(this.dataset.sectionId)) return;
          const variant = event.data.variant;
          if (!variant) return;
          this.currentVariantId = String(variant.id || '');
          this.framePrice = Number(variant.price || 0);
          this.frameCompareAtPrice = Number(variant.compare_at_price || 0);
          this.variantAvailable = Boolean(variant.available);
          const updatedButton =
            event.data.html && event.data.html.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
          const updatedButtonText = updatedButton && updatedButton.querySelector('span');
          this.nativeSubmitDisabled = !updatedButton || updatedButton.hasAttribute('disabled');
          if (updatedButtonText) this.nativeSubmitLabel = updatedButtonText.textContent.trim();
          this.applySelection();
        });
      }

      readPreviewMap() {
        const node = this.querySelector('[data-optical-preview-map]');
        if (!node) return {};
        try {
          return JSON.parse(node.textContent || '{}');
        } catch (error) {
          console.warn('Optical lens preview data could not be read.', error);
          return {};
        }
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        this.afterpayObserver?.disconnect();
        if (this.form && this.onFormSubmit) this.form.removeEventListener('submit', this.onFormSubmit, true);
        this.previewSyncTimers.forEach((timer) => window.clearTimeout(timer));
      }

      applySelection() {
        const purpose = this.querySelector('[data-optical-purpose]:checked');
        const purposeValue = purpose ? purpose.dataset.opticalPurpose : 'standard';
        const finishGroups = this.querySelectorAll('[data-optical-finish-group]');
        const tintGroup = this.querySelector('[data-optical-tint-group]');

        finishGroups.forEach((group) => {
          const active = group.dataset.opticalFinishGroup === purposeValue;
          group.hidden = !active;
          group.disabled = !active;
          group.querySelectorAll('input').forEach((input) => {
            input.disabled = !active || !input.dataset.opticalServiceVariantId || input.dataset.opticalServiceAvailable !== 'true';
            if (input.disabled) input.checked = false;
          });
        });

        const activeGroup = this.querySelector(`[data-optical-finish-group="${purposeValue}"]`);
        let selectedFinish = activeGroup && activeGroup.querySelector('[data-optical-upgrade-cents]:checked');
        if (activeGroup && !selectedFinish) {
          selectedFinish = activeGroup.querySelector('[data-optical-upgrade-cents]:not(:disabled)');
          if (selectedFinish) selectedFinish.checked = true;
        }

        const tintActive = purposeValue === 'sunglasses';
        if (tintGroup) {
          tintGroup.hidden = !tintActive;
          tintGroup.disabled = !tintActive;
          tintGroup.querySelectorAll('[data-optical-tint]').forEach((input) => {
            input.disabled = !tintActive;
            if (!tintActive) input.checked = false;
          });
          if (tintActive && !tintGroup.querySelector('[data-optical-tint]:checked')) {
            const defaultTint = tintGroup.querySelector('[data-optical-tint]');
            if (defaultTint) defaultTint.checked = true;
          }
        }

        const upgrade = selectedFinish ? Number(selectedFinish.dataset.opticalUpgradeCents || 0) : 0;
        const isPaidUpgrade = purposeValue !== 'standard';
        const total = Math.max(0, this.framePrice + upgrade - (isPaidUpgrade ? this.comboDiscount : 0));
        const isUnavailable = !this.variantAvailable || this.nativeSubmitDisabled;
        const serviceConfigured = !isPaidUpgrade || Boolean(selectedFinish && selectedFinish.dataset.opticalServiceVariantId);
        const serviceAvailable = !isPaidUpgrade || selectedFinish?.dataset.opticalServiceAvailable === 'true';
        const isCheckoutBlocked = isUnavailable || (isPaidUpgrade && (!this.upgradesEnabled || !serviceConfigured || !serviceAvailable));
        const buttonLabel = this.buttonLabel(purposeValue, total, isUnavailable);

        this.selection = { purposeValue, selectedFinish, upgrade, total, isPaidUpgrade, serviceConfigured, serviceAvailable };

        if (this.context) {
          this.context.hidden = purposeValue !== 'standard';
          this.context.textContent = 'Includes the original clear display lenses.';
        }

        if (this.submitButton) {
          this.submitButton.disabled = isCheckoutBlocked;
          this.submitButton.setAttribute('aria-disabled', String(isCheckoutBlocked));
        }
        if (this.submitButtonText) this.submitButtonText.textContent = buttonLabel;

        if (this.prescriptionButton && this.standardLensPrice > 0) {
          const blueRx = new URLSearchParams(location.search).get('purpose') === 'blue-light-rx' && !this.isRimless && this.blueRxLensPrice > 0;
          const total = Math.max(0, this.framePrice + (blueRx ? this.blueRxLensPrice : this.standardLensPrice) - this.comboDiscount);
          this.prescriptionButton.textContent = blueRx
            ? `Prescription blue-light from ${this.formatCompactMoney(total)}`
            : `Build prescription glasses — from ${this.formatMoney(total)} total`;
        }

        this.syncMainPrice(total, upgrade, isPaidUpgrade);
        this.syncStickySubmit(isCheckoutBlocked, buttonLabel, purposeValue, total);
        this.scheduleLensPreview(purposeValue);

        if (!this.status) return;
        if (!this.variantAvailable) {
          this.status.textContent = 'This frame colour is currently unavailable.';
          this.status.dataset.blocked = 'true';
        } else if (this.nativeSubmitDisabled) {
          this.status.textContent = 'This frame cannot currently be added to cart.';
          this.status.dataset.blocked = 'true';
        } else if (isPaidUpgrade && !this.upgradesEnabled) {
          this.status.textContent = this.isRimless
            ? 'Non-prescription lens upgrades for rimless frames require an optical suitability check. Contact our optical team for help.'
            : 'This lens upgrade is not available for online ordering on this frame.';
          this.status.dataset.blocked = 'true';
        } else if (isPaidUpgrade && (!serviceConfigured || !serviceAvailable)) {
          this.status.textContent = 'This lens option is temporarily unavailable. Please choose another option or contact our optical team.';
          this.status.dataset.blocked = 'true';
        } else {
          this.status.textContent = '';
          this.status.dataset.blocked = 'false';
        }
      }

      scheduleLensPreview(purposeValue) {
        this.previewSyncTimers.forEach((timer) => window.clearTimeout(timer));
        this.previewSyncTimers = [0, 120, 360].map((delay) => window.setTimeout(() => {
          this.syncLensPreview(purposeValue);
        }, delay));
      }

      syncLensPreview(purposeValue) {
        const variantId = String(this.form?.querySelector('[name="id"]')?.value || this.currentVariantId || '');
        this.currentVariantId = variantId;
        const variant = this.previewMap[variantId] || null;
        const tintValue = this.querySelector('[data-optical-tint]:checked')?.value || 'Grey';
        const tintKey = String(tintValue).trim().toLowerCase();
        const wantsTint = purposeValue === 'sunglasses';
        const previewUrl = wantsTint ? (variant?.[tintKey] || variant?.source) : variant?.source;
        if (!previewUrl) return;

        const sectionId = CSS.escape(String(this.dataset.sectionId || ''));
        const targets = [
          ...document.querySelectorAll(`[data-optical-mobile-gallery][data-section-id="${sectionId}"] .optical-mobile-product-gallery__item:first-child img`),
          ...document.querySelectorAll(`#MediaGallery-${sectionId} .product__media-item.is-active img`),
          ...document.querySelectorAll('.MagicToolboxSlide.active-magic-slide a.MagicZoomPlus img, a.MagicZoomPlus[id^="zoom"] img')
        ];
        const uniqueTargets = [...new Set(targets)];
        uniqueTargets.forEach((image) => this.applyPreviewToImage(image, previewUrl, variant?.title, wantsTint, tintValue));

        const zoomLink = document.querySelector('.MagicToolboxSlide.active-magic-slide a.MagicZoomPlus, a.MagicZoomPlus[id^="zoom"]');
        if (zoomLink) {
          if (!zoomLink.dataset.opticalOriginalHref) zoomLink.dataset.opticalOriginalHref = zoomLink.getAttribute('href') || '';
          zoomLink.setAttribute('href', previewUrl);
          if (window.MagicZoom && typeof window.MagicZoom.update === 'function') {
            try {
              window.MagicZoom.update(zoomLink, previewUrl, previewUrl);
            } catch (_error) {
              // The visible image and href are already updated; MagicZoom can recover on its next activation.
            }
          }
        }

        this.dispatchEvent(new CustomEvent('optical:lens-preview-change', {
          bubbles: true,
          detail: { variantId, purpose: purposeValue, tint: wantsTint ? tintValue : null, url: previewUrl }
        }));
      }

      applyPreviewToImage(image, url, variantTitle, wantsTint, tintValue) {
        if (!image.dataset.opticalOriginalSrc) image.dataset.opticalOriginalSrc = image.currentSrc || image.src || '';
        if (!image.dataset.opticalOriginalSrcset) image.dataset.opticalOriginalSrcset = image.getAttribute('srcset') || '';
        if (!image.dataset.opticalOriginalSizes) image.dataset.opticalOriginalSizes = image.getAttribute('sizes') || '';
        if (!image.dataset.opticalOriginalAlt) image.dataset.opticalOriginalAlt = image.getAttribute('alt') || '';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
        image.alt = wantsTint
          ? `${variantTitle || 'Optical frame'} with ${tintValue} sunglass lenses`
          : image.dataset.opticalOriginalAlt;
      }

      restorePreviewImages() {
        document.querySelectorAll('[data-optical-original-src]').forEach((image) => {
          image.src = image.dataset.opticalOriginalSrc;
          if (image.dataset.opticalOriginalSrcset) image.setAttribute('srcset', image.dataset.opticalOriginalSrcset);
          else image.removeAttribute('srcset');
          if (image.dataset.opticalOriginalSizes) image.setAttribute('sizes', image.dataset.opticalOriginalSizes);
          else image.removeAttribute('sizes');
          image.alt = image.dataset.opticalOriginalAlt || image.alt;
        });
        document.querySelectorAll('[data-optical-original-href]').forEach((link) => {
          if (link.dataset.opticalOriginalHref) link.setAttribute('href', link.dataset.opticalOriginalHref);
        });
      }

      syncMainPrice(total, upgrade, isPaidUpgrade) {
        this.syncAfterpayAmount(total);
        const priceContainer = document.getElementById(`price-${this.dataset.sectionId}`);
        const priceRoot = priceContainer?.querySelector('.price');
        if (!priceRoot) return;

        const compareTotal = this.frameCompareAtPrice > this.framePrice
          ? this.frameCompareAtPrice + upgrade
          : 0;
        updateCityRrpPrice(priceRoot, { price: total, compareAtPrice: compareTotal, variantPrice: total });
        priceContainer.dataset.opticalDisplayedTotalCents = String(total);

        const installmentForm = document.getElementById(`product-form-installment-${this.dataset.sectionId}`);
        if (installmentForm) {
          installmentForm.hidden = isPaidUpgrade;
          installmentForm.setAttribute('aria-hidden', String(isPaidUpgrade));
        }
      }

      syncAfterpayAmount(total) {
        const amount = (total / 100).toFixed(2);
        this.afterpayContainer?.querySelectorAll('square-placement[data-page-type="product"]:not([data-safestyle-afterpay])').forEach((placement) => {
          if (placement.getAttribute('data-amount') !== amount) placement.setAttribute('data-amount', amount);
        });
      }

      handleFormSubmit(event) {
        const selection = this.selection;
        if (!selection || !selection.isPaidUpgrade) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitButton?.disabled || this.adding) return;
        this.addUpgradeToCart();
      }

      buildUpgradeItems() {
        const selection = this.selection;
        const frameId = Number(this.form?.querySelector('[name="id"]')?.value || 0);
        const serviceId = Number(selection?.selectedFinish?.dataset.opticalServiceVariantId || 0);
        const serviceSku = selection?.selectedFinish?.dataset.opticalServiceSku || '';
        const quantity = Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value || 1));
        if (!frameId || !serviceId || !selection?.serviceAvailable || !this.variantAvailable) {
          throw new Error('configuration_unavailable');
        }

        const groupId = globalThis.crypto?.randomUUID?.() || `opt-np-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        const shared = {
          '_city_rx_sunglasses_group': groupId,
          '_city_rx_order_type': 'optical-non-prescription',
          '_city_rx_sunglasses_configuration': serviceSku,
          '_city_rx_sunglasses_frame_variant': String(frameId)
        };
        const tint = this.querySelector('[data-optical-tint]:checked')?.value || '';
        const finishLabel = selection.selectedFinish.value || '';
        const serviceProperties = {
          ...shared,
          '_city_rx_sunglasses_service': 'true',
          '_city_rx_restore_version': '1',
          'Lens purpose': selection.purposeValue === 'blue-light' ? 'Blue-light' : 'Sunglasses',
          ...(selection.purposeValue === 'blue-light' ? { 'Lens coating': finishLabel } : { 'Lens type': finishLabel, 'Lens tint': tint }),
          '_Production Ready': 'No — lens fitting required',
          '_Staff Action': 'Fit the selected non-prescription lenses to the new optical frame'
        };
        return {
          groupId,
          purpose: selection.purposeValue,
          serviceSku,
          items: [
            { id: frameId, quantity, properties: { ...shared, '_city_rx_sunglasses_parent': 'true' } },
            { id: serviceId, quantity, properties: serviceProperties }
          ]
        };
      }

      async addUpgradeToCart() {
        if (this.adding) return;
        this.adding = true;
        let groupId = '';
        let response = null;
        let cartError = '';
        const originalLabel = this.submitButtonText?.textContent || '';
        if (this.submitButton) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        }
        if (this.submitButtonText) this.submitButtonText.textContent = 'Adding…';

        try {
          const built = this.buildUpgradeItems();
          groupId = built.groupId;
          const drawer = document.querySelector('cart-drawer');
          const sectionIds = typeof drawer?.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map((section) => section.id).filter(Boolean)
            : ['cart-drawer', 'cart-icon-bubble'];
          const root = window.Shopify?.routes?.root || '/';
          const request = await fetch(window.routes?.cart_add_url || `${root}cart/add.js`, {
            method: 'POST',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: built.items, sections: sectionIds.join(','), sections_url: window.location.pathname })
          });
          response = await request.json().catch(() => ({}));
          if (!request.ok || response.status) throw new Error(response.description || 'cart_add_failed');

          const verify = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
          if (!verify.ok) throw new Error('cart_verify_failed');
          const cart = await verify.json();
          const grouped = (cart.items || []).filter((item) => item.properties?._city_rx_sunglasses_group === groupId);
          if (grouped.length !== 2 || !grouped.some((item) => item.properties?._city_rx_sunglasses_parent === 'true') || !grouped.some((item) => item.properties?._city_rx_sunglasses_service === 'true')) {
            throw new Error('cart_add_incomplete');
          }

          window.dataLayer?.push({
            event: 'optical_nonprescription_add',
            lens_purpose: built.purpose,
            lens_service_sku: built.serviceSku,
            frame_variant_id: String(built.items[0].id)
          });
          if (window.CityCartEdit?.refreshCartDrawer) await window.CityCartEdit.refreshCartDrawer(true, 1);
          else if (drawer?.renderContents && response.sections) drawer.renderContents(response);
          else {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'optical-non-prescription' } }));
            drawer?.open?.();
          }
        } catch (error) {
          const rolledBack = !groupId || await this.rollbackUpgradeGroup(groupId).catch(() => false);
          cartError = error.message === 'configuration_unavailable'
            ? 'This frame or lens option is no longer available. Review your selection and try again.'
            : rolledBack
              ? 'We could not add the frame and lens upgrade. Nothing incomplete was left in your cart. Please try again.'
              : 'We could not confirm that the incomplete items were removed. Please check your cart or contact our team before checkout.';
        } finally {
          this.adding = false;
          if (this.submitButton) this.submitButton.classList.remove('loading');
          if (this.submitButtonText && !this.selection) this.submitButtonText.textContent = originalLabel;
          this.applySelection();
          if (cartError && this.status) {
            this.status.textContent = cartError;
            this.status.dataset.blocked = 'true';
          }
        }
      }

      async rollbackUpgradeGroup(groupId) {
        const root = window.Shopify?.routes?.root || '/';
        const request = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
        if (!request.ok) throw new Error('cart_rollback_read_failed');
        const cart = await request.json();
        const updates = {};
        (cart.items || []).forEach((item) => {
          if (item.properties?._city_rx_sunglasses_group === groupId) updates[item.key] = 0;
        });
        if (Object.keys(updates).length) {
          const removal = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ updates })
          });
          if (!removal.ok) throw new Error('cart_rollback_update_failed');
        }
        const verification = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
        if (!verification.ok) throw new Error('cart_rollback_verify_failed');
        const verifiedCart = await verification.json();
        if ((verifiedCart.items || []).some((item) => item.properties?._city_rx_sunglasses_group === groupId)) {
          throw new Error('cart_rollback_incomplete');
        }
        return true;
      }

      buttonLabel(purposeValue, total, unavailable) {
        if (unavailable) return 'Sold out';
        const formattedTotal = this.formatMoney(total);
        if (purposeValue === 'blue-light') return `Add with Blue Filter (non-prescription) lenses — ${formattedTotal}`;
        if (purposeValue === 'sunglasses') return `Add as sunglasses — ${formattedTotal}`;
        return `Add frame as shown — ${formattedTotal}`;
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          const wrapper = document.createElement('span');
          wrapper.innerHTML = window.Shopify.formatMoney(cents, this.moneyFormat);
          return (wrapper.textContent || wrapper.innerText || '').trim();
        }
        if (this.moneyFormat) {
          const moneyWithDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
            const number = (Number(value) || 0) / 100;
            const parts = number.toFixed(precision).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return parts.join(decimal);
          };
          const replacements = {
            amount: moneyWithDelimiters(cents),
            amount_no_decimals: moneyWithDelimiters(cents, 0),
            amount_with_comma_separator: moneyWithDelimiters(cents, 2, '.', ','),
            amount_no_decimals_with_comma_separator: moneyWithDelimiters(cents, 0, '.', ',')
          };
          const wrapper = document.createElement('span');
          wrapper.innerHTML = this.moneyFormat.replace(
            /\{\{\s*(amount(?:_no_decimals_with_comma_separator|_with_comma_separator|_no_decimals)?)\s*\}\}/,
            (_, key) => replacements[key] || replacements.amount
          );
          return (wrapper.textContent || wrapper.innerText || '').trim();
        }
        try {
          return new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.currency }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      }

      formatCompactMoney(cents) {
        const amount = (Number(cents) || 0) / 100;
        try {
          return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(Number(cents) % 100 === 0 ? 0 : 2)}`;
        }
      }

      compactButtonLabel(purposeValue, total, unavailable) {
        if (unavailable) return 'Sold out';
        const formattedTotal = this.formatCompactMoney(total);
        if (purposeValue === 'blue-light') return `Blue Filter (non-prescription) — ${formattedTotal}`;
        if (purposeValue === 'sunglasses') return `Sunglasses — ${formattedTotal}`;
        return `As shown — ${formattedTotal}`;
      }

      syncStickySubmit(blocked, buttonLabel, purposeValue, total) {
        const token = ++this.stickySyncToken;
        const sync = () => {
          if (token !== this.stickySyncToken) return;
          const stickySubmit = document.querySelector('[data-city-sticky-submit]');
          if (!stickySubmit) return;
          stickySubmit.disabled = blocked;
          stickySubmit.setAttribute('aria-disabled', String(blocked));
          stickySubmit.setAttribute('aria-label', buttonLabel);
          const desktopLabel = stickySubmit.querySelector('[data-optical-sticky-nonprescription-desktop]');
          const mobileLabel = stickySubmit.querySelector('[data-optical-sticky-nonprescription-mobile]');
          if (desktopLabel && mobileLabel) {
            desktopLabel.textContent = buttonLabel;
            mobileLabel.textContent = this.compactButtonLabel(purposeValue, total, buttonLabel === 'Sold out');
          } else {
            stickySubmit.textContent = buttonLabel;
          }
        };

        sync();
        [120, 450].forEach((delay) => window.setTimeout(sync, delay));
      }
    }
  );
}
